<template>
  <div class="w-full px-[20px] mt-[24px] text-[16px]">
    <Image
      v-if="txBanner.state == 'Enabled'"
      @click="handleJumpLink"
      class="w-[340px] h-[174px] rounded-2xl"
      :src="txBanner.picture"
      alt=""
    />
    <div class="mt-[20px]">
      <span>{{ $t("Saque.EnterAmount.MyBalance") }}</span>
      <div class="flex justify-between items-center mt-[25px] ml-[13px]">
        <div class="flex items-center gap-[13px]">
          <Image class="w-[24px] h-[24px]" :src="rIcon" alt="" />
          <span class="w-[220px]">
            {{ formatter().format(sharedData.totalMoney) }}
            <span class="text-[12px]">R$</span>
          </span>
        </div>
      </div>
      <div class="w-full h-[1px] bg-white/15 mt-[13px]"></div>
      <div class="relative block mt-[20px]">
        <input
          class="webkit-tap-none block border-none bg-[#2C7952]/40 w-full h-[44px] rounded-xl py-2 pl-[50px] pr-3 shadow-sm focus:bg-[#2C7952]/70"
          :placeholder="`valor(${limitMin} ~ ${limitMax})`"
          v-model="sharedData.amount"
          :disabled="sharedData.limitAmount > 0 || sharedData.totalMoney == 0"
          @input="handleInput"
        />
        <span class="w-[24px] h-[24px] absolute left-[15px] top-[11px] text-[#FFDF12]">
          R$
        </span>
      </div>
      <template v-if="Number(sharedData.limitAmount) > 0">
        <div
          class="w-full h-[54px] mt-[10px] pl-[13px] rounded-xl border-[1px] border-solid border-[#fff] flex items-center"
        >
          <div class="flex items-center gap-[13px]">
            <Image class="w-[24px] h-[24px]" :src="Icon" alt="" />
            <span class="w-[250px] leading-[18px] text-[15px] text-[#fff]/45">
              {{
                $t("Saque.EnterAmount.WithdrawalRestrictions", {
                  limitAmount: formatter().format(sharedData.limitAmount),
                })
              }}
            </span>
          </div>
        </div>
      </template>
      <div class="text-[#fff]/50">
        <button
          :class="{
            'w-full h-[42px] mt-[60px] block mx-auto rounded-lg border-solid bg-[#151A1F] border-[#fff]/50 border-[1px] text-center': true,
            'bg-[#64F765]  text-[#151A1F]':
              sharedData.amount && +sharedData.amount >= limitMin,
          }"
          :disabled="!(sharedData.amount && +sharedData.amount >= limitMin)"
          @click="next"
        >
          {{ $t("meu.Sake") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getAdvertisingSpaceInfo } from "@/api/saque";
import { formatter } from "@/utils";
import rIcon from "../images/rIcon.png";
import Icon from "../images/icon.png";

const route = useRoute();
const router = useRouter();
const searchParams = ref(route.query);
const limitMin = Number(searchParams.value.min) || 0;
const limitMax = Number(searchParams.value.max) || 0;
const txBanner = ref<any>({});
const sharedData: any = inject("sharedData");
const emit = defineEmits(["next"]);
const next = () => {
  emit("next");
};

// 查询广告位信息
const queryAdvertisingSpaceInfo = async () => {
  try {
    const { data, code } = await getAdvertisingSpaceInfo({ language: "pt" });
    if (code === 1) {
      txBanner.value = data || {};
    }
  } catch (error) {
    console.log(error);
  }
};
const handleInput = (e: any) => {
  const value = e.target.value.replace(/[^0-9.]+|(?:\.\d)\./g, "");
  if (sharedData.value.totalMoney == 0) {
    return;
  }
  const min =
    limitMax > sharedData.value.totalMoney ? sharedData.value.totalMoney : limitMax;
  const num = Number(value) > min ? min.toString() : value;
  // 小数点后面最多输入两位数
  const formattedNum = num.includes(".")
    ? num.split(".")[0] + "." + num.split(".")[1].slice(0, 2)
    : num;
  sharedData.value.amount = formattedNum;
  if (sharedData.value.amount == 0) {
    sharedData.value.amount = "";
  }
};
//点击图片跳转
const handleJumpLink = () => {
  if (txBanner.value.hyperlink) {
    if (txBanner.value.hyperlinkType === "BUILT_IN_LINK") {
      // 内置链接
      const queryString = new URLSearchParams(searchParams.value as any).toString();
      const activityIdParam = txBanner.value.activityId
        ? `&activityId=${txBanner.value.activityId}`
        : "";
      const finalUrl = `${txBanner.value.hyperlink}?${queryString}${activityIdParam}`;
      router.push(finalUrl);
    } else if (
      txBanner.value.hyperlinkType === "CUSTOM_LINK" ||
      txBanner.value.jumpMethod === "INNER_JUMP"
    ) {
      // 自定义链接 或 外跳链接
      window.open(txBanner.value.hyperlink, "_blank");
    } else if (txBanner.value.jumpMethod === "EXTERNAL_JUMP") {
      window.location.href = txBanner.value.hyperlink;
    }
  }
};

onMounted(() => {
  queryAdvertisingSpaceInfo();
});
</script>

<style lang="scss" scoped></style>
